import Config from "../../config";
import UserTopbarSection from "./user-topbar-section";
import MainMenu from "../../../jamibet/desktop-components/site/main-menu";

export default function Header() {
	return <header class="website-header bg-harif-900 text-white">
	    <UserTopbarSection />
		<div class="flex justify-between bg-harif-900 border-b border-t border-b-harifzinc-950 border-t-harifzinc-700">
		    <div class="w-32 grow">
				<a class="header-logo inline-block pt-2 px-4" href="/">
			        <img src={Config.logourl} alt={Config.title} style="max-width: 244px; max-height:45px" />
			    </a>
			</div>
		    <MainMenu />
		</div>
	</header>;
}
